(ns ncr.fragment.props.date
  (:require [uix.core.alpha :as uix]
            [ncr.widgets.core :as w]
            [tick.core :as t]
            [tick.locale-en-us]
            [ncr.fragment.attachment-markup :as am]
            [ncr.etc.util :as u]
            [ncr.etc.pf :as pf]
            [ncr.etc.pubsub :as ps]
            [ncr.etc.parse-dates :as pd]
            [java.time :as jt]
            [cljc.java-time.local-date]))


(defn parse-all [s]
  (pd/parse-all s))

(defn parse [s] (first (parse-all s)))

(def formatter (t/formatter "yyyy/MM/dd"))

(defn to-string [d]
  (or (some->> d (t/format formatter)) ""))

(defn- equals [a b]
  (cond
    (and (instance? jt/LocalDate a) (instance? jt/LocalDate b))
    (t/= a b)

    (and (nil? a) (nil? b))
    true

    :else
    false))

(defn c-date-property [props initial update!]
  (let
    [label (get props :label key)
     id (uix/memo #(gensym) [])
     update!
     (fn [date]
       (update! date (u/format "%s: %s" label (to-string date))))

     {:keys [model calendar-visible?]}
     @(ps/sub-reducer-map!
        {:calendar-visible? false
         :model
         {:string (to-string initial)
          :date initial
          :calendar-date (or initial (t/today))
          :error nil}}
        {[id :toggle-calendar-visible]
         (fn [state]
           (as-> state $
             (update $ :calendar-visible? not)
             (if-let [d (-> state :model :date)]
               (assoc-in $ [:model :calendar-date] d)
               $)))

         [id :hide-calendar]
         (fn [state]
           (as-> state $
             (assoc $ :calendar-visible? false)
             (if-let [d (-> state :model :date)]
               (assoc-in $ [:model :calendar-date] d)
               $)))

         [id :update]
         (fn [state value]
           (assoc-in state [:model :string] value))

         [id :save-date-string]
         (fn [{{:keys [string calendar-date]} :model :as state}]
           (assoc state :model
             (merge {:string string :calendar-date calendar-date}
               (try
                 (let [date (when (seq string) (parse string))]
                   (when-not (equals initial date)
                     (update! date))
                   {:date date
                    :calendar-date
                    (cond
                      (some? date) date
                      (empty? string) (t/today)
                      :else calendar-date)})
                 (catch js/Error _
                   {:error "Invalid Date"})))))

         [id :save-date]
         (fn [state date]
           (when-not (equals initial date)
             (update! date))
           (assoc state :model {:string (to-string date) :date date}))

         [id :set-calendar-date]
         (fn [state d]
           (assoc-in state [:model :calendar-date] d))})

     {:keys [class c-suggestions]} (.get am/useStore (partial am/get-property-props id))]

    (let [string (to-string initial)]
      (uix/with-effect [string]
        (ps/pub! [[id :update] string])))

    (uix/effect!
      (fn []
        (am/register-property id
          {:update! (fn [value]
                      (ps/pub-sync! [[id :update] value])
                      (ps/pub! [[id :save-date-string]]))
           :validate #(when (seq %) (parse %))
           :get-suggestions #(when (seq %) (parse-all %))
           :to-string to-string
           :type :date}))
      [id props])

    [pf/c-form-group
     (let [error (get model :error)]
       {:class class
        :label label
        :helper-text-invalid error
        :validated (when error :error)
        :field-id id})

     [pf/c-popover
      {:position :bottom
       :class :ncr-date-prop-calendar
       :has-auto-width true
       :has-no-padding true
       :show-close false
       :is-visible calendar-visible?
       :should-close
       (fn [_ _ _]
         (ps/pub! [[id :toggle-calendar-visible]])
         true)

       :body-content
       [:<>
        [:div
         [pf/c-tooltip {:content [:span "Show Today"]}
          [pf/c-button
           {:variant :plain
            :class :ncr-date-prop-calendar-today-btn
            :on-click #(ps/pub! [[id :set-calendar-date] (t/today)])}
           [w/c-mdi-icon {:icon :calendar-outline}]]]]

        [pf/c-calendar-month
         {:week-start 1
          :date (-> model :calendar-date js/Date.)
          :on-change
          (fn [date]
            (ps/pub! [[id :hide-calendar]])
            (ps/pub!
              [[id :save-date]
               (t/date date)]))}]]}
      [:<>
       [pf/c-input-group
        [pf/c-text-input
         {:id id
          :value (get model :string "")
          :on-change
          (fn [value _]
            (ps/pub-sync! [[id :update] value]))

          :on-key-up
          (fn [event]
            (when (= (.-key event) "Enter")
              (.preventDefault event)
              (ps/pub! [[id :save-date-string]])))

          :on-blur
          (fn [_]
            (ps/pub! [[id :save-date-string]]))}]

        [pf/c-input-group-text
         [pf/c-button
          {:variant :plain :class :pf-u-p-0
           :on-click
           #(ps/pub! [[id :toggle-calendar-visible]])}
          [w/c-mdi-icon {:icon :calendar-month-outline}]]]]
       [c-suggestions]]]]))

(defn c-date-label [value]
  (let [s (to-string value)]
    [:<>
     s
     [w/c-mdi-icon {:icon :calendar-month-outline :class :pf-u-pl-xs}]]))

#_(parse-date* "13.07.75")

#_(t/date "13.07.1975")

#_(let [m1 (Date. (t/date "2021-09-28"))
        m2 (Date. (t/date))]
    (equals' m1 m2)
    (tagged-value m1))


#_(def d (t/date))

#_(= d (t/date "2021-09-28"))
